import type { Market, PricingConfig } from './types';

export const PRICING_CONFIG: Record<Market, PricingConfig> = {
  UK: {
    currency: 'GBP',
    rates: {
      walls: 8,
      ceiling: 9,
      skirting: 7,
      door: 85,
      radiator: 20,
      wallpaperRemoval: 8,
      stainBlocking: 4
    },
    minimumCharge: 250,
    travelCharge: 45,
    conditionMultipliers: {
      good: 1,
      minorRepairs: 1.12,
      noticeableRepairs: 1.3,
      newPlaster: 1.18
    },
    colourMultipliers: {
      similar: 1,
      noticeable: 1.08,
      darkToLight: 1.15
    },
    materialMultipliers: {
      standard: 1,
      premium: 1.15
    },
    additionalMultipliers: {
      highCeiling: 1.12,
      difficultAccess: 1.1,
      furnished: 1.08
    },
    regionMultipliers: {
      standard: 1,
      londonSouthEast: 1.25,
      warsaw: 1
    },
    range: { low: 0.9, high: 1.15 },
    roundingStep: 10
  },
  PL: {
    currency: 'PLN',
    rates: {
      walls: 28,
      ceiling: 30,
      skirting: 14,
      door: 250,
      radiator: 50,
      wallpaperRemoval: 25,
      stainBlocking: 12
    },
    minimumCharge: 700,
    travelCharge: 150,
    conditionMultipliers: {
      good: 1,
      minorRepairs: 1.12,
      noticeableRepairs: 1.3,
      newPlaster: 1.18
    },
    colourMultipliers: {
      similar: 1,
      noticeable: 1.08,
      darkToLight: 1.15
    },
    materialMultipliers: {
      standard: 1,
      premium: 1.15
    },
    additionalMultipliers: {
      highCeiling: 1.12,
      difficultAccess: 1.1,
      furnished: 1.08
    },
    regionMultipliers: {
      standard: 1,
      londonSouthEast: 1,
      warsaw: 1.18
    },
    range: { low: 0.9, high: 1.15 },
    roundingStep: 50
  }
};
